export default async ({ commit, rootGetters }) => {
    let priceTheme = await rootGetters['theme/theme'].coef
    commit('setPriceThem', { value: priceTheme, coef: priceTheme })
}